module.exports = __webpack_public_path__ + "confirm.modal-34b74ac3.html";